<span><img width="14" height="14" class="mr-3" src="assets/images/Login-Icon.svg" alt="">
    <span class="pointer">{{label}}</span></span>
